import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router";
import Masonry from "react-masonry-css";
import axios from "axios";
import moment from "moment";

const Portfolio = () => {
  const navigate = useNavigate();
  const { cmpnyNo, url } = useOutletContext();
  const [portfolio, setPortfolio] = useState([]);

  useEffect(() => {
    if (!cmpnyNo) return;
    getPortfolio(cmpnyNo);
  }, [cmpnyNo]);

  const getPortfolio = async (cmpnyNo) => {
    const url = "/api/portMgmtList";
    const body = {
      cmpnyNo,
      useYn: "Y",
      notitleYn: "Y",
      offset: 0,
      pageNumber: 0,
      pageSize: 6,
      paged: true,
    };

    try {
      const res = await axios.post(url, body);
      // const test = imgHandler(res.data.content[0].imgUrl);
      // console.log(test);
      setPortfolio(res.data.content);
    } catch (error) {
      console.log(error);
    }
  };

  const breakpointColumnsObj = {
    default: 3,
    1400: 3,
    1050: 2,
    767: 1,
  };

  return (
    <div className="portfolio">
      <div className="info">
        <strong>포트폴리오</strong>
        <p>실제 사례를 보여드립니다.</p>
      </div>
      <div className="inner">
        <Masonry breakpointCols={breakpointColumnsObj} className="grid" columnClassName="column">
          {portfolio.map((item) => (
            <div onClick={() => navigate(`/shop/${url}/portfolioView/${item.portNo}`)}>
              {item.imgUrl ? <img src={imgHandler(item.imgUrl)} /> : <div className="bg"></div>}
              <p>
                <span>{item.title}</span>
                <span>{item.updateDt}</span>
              </p>
            </div>
          ))}
        </Masonry>
      </div>
    </div>
  );
};

export default Portfolio;
